import apiClient from "../api/apiClient";

export const fetchCourseList = async () => {
    return apiClient.get("/group/course-list");
};

export const fetchBranchCourseList = async () => {
    return apiClient.get("/group/branch-course-list");
};

export const fetchBranchList = async () => {
    return apiClient.get("/group/branch-list");
};

export const fetchBatchList = async () => {
    return apiClient.get("/group/branch/batches");
};

export const createBranch = async (branchData) => {
    return apiClient.post("/group/create-branch", branchData);
};

export const createCourse = async (coursesArray) => {
    return apiClient.post("/group/create-course", { courses: coursesArray });
};

export const mapBranchCourse = async (branchId, courseId) => {
    return apiClient.post("/group/branch-course-mapping", {
        branchId: branchId,
        courses: [Number(courseId)]
    });
};

export const createBatches = async (payload) => {
    return apiClient.post("/group/branch/create-batches", payload);
};

export const checkCourseStudents = async (branchCourseId) => {
    return apiClient.post(`/group/checkcoursestudents/${branchCourseId}`);
};

export const getCourseStudentDetails = async (branchCourseId) => {
    return apiClient.post(`/group/coursestudentdetails/${branchCourseId}`);
};

export const deleteCourseBatch = async (branchCourseId) => {
    return apiClient.post(`/group/deletecoursebatch/${branchCourseId}`);
};

/* ---------- UPDATE & DELETE OPERATIONS ---------- */

export const updateBranch = async (branchData) => {
    return apiClient.post("/group/update-branch", branchData);
};

export const deleteBranch = async (id) => {
    return apiClient.post(`/group/deactivate-branch/${id}`);
};

export const updateCourse = async (courseData) => {
    return apiClient.post("/group/update-course", courseData);
};

export const deleteCourse = async (id) => {
    return apiClient.post(`/group/deactivate-course/${id}`);
};

export const courseAction = async (payload) => {
    return apiClient.post("/group/course-action", payload);
};

export const updateBatch = async (batchData) => {
    return apiClient.post("/group/update-batch", batchData);
};

export const deleteBatch = async (id) => {
    return apiClient.post(`/group/deactivate-batch/${id}`);
};

export const getPincodeDetails = async (pincode) => {
    try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
        if (!response.ok) throw new Error("Failed to fetch pincode data");
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Pincode API Error:", error);
        throw error;
    }
};
